module.exports = __webpack_public_path__ + "static/media/signin-banner.f635ca1f.svg";